export default {
    setDeviceId(state, deviceId) {
        state.deviceId = deviceId;
    },

    setConfigInfo(state, configInfo) {
        state.configInfo = configInfo;
        localStorage.setItem('configInfo', JSON.stringify(configInfo))
    },

    setUuid(state, uuid) {
        state.uuid = uuid;
        localStorage.setItem('uuid', JSON.stringify(uuid))
    },

    clearUuid(state) {
        state.uuid = '';
        localStorage.removeItem('uuid');
    },

    setUserInfo(state, userInfo) {
        state.userInfo = userInfo
        localStorage.setItem('userInfo', JSON.stringify(userInfo))
    },

    setNoticeInfo(state, noticeInfo) {
        state.noticeInfo = noticeInfo
        localStorage.setItem('noticeInfo', JSON.stringify(noticeInfo))
    },

    setRecents(state, recents) {
        state.recents = recents
        localStorage.setItem('recents', JSON.stringify(recents))
    },

    setHistoryGames(state, historyGames) {
        state.historyGames = historyGames
        localStorage.setItem('historyGames', JSON.stringify(historyGames))
    },

    setHomeGames(state, homeGames) {
        state.homeGames = homeGames
        localStorage.setItem('homeGames', JSON.stringify(homeGames))
    },

    clearHistoryGames(state) {
        state.historyGames = []
        localStorage.removeItem('historyGames')
    },

    clearUserInfo(state) {
        state.userInfo = {}
        localStorage.removeItem('userInfo')
    }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js